/* eslint-disable react/prop-types */
import React from "react";
import ReleasesTable from "./ReleasesTable";

export default function FinalApproval() {
  return (
    <>
      <ReleasesTable
        filterBy="Approval Released"
        approval_status="Budget Approval Released"
        title="Final Approval Review"
        query_type="select_by_status_comm"
        return_status="Final Internal Controls Returned"
        showHistoryTab={true}
      />
    </>
  );
}
